
  
  
  import FETCHING from '../../library/fetching'
  // import DATAMASTER from '../../library/dataMaster'
  
  export default {
    data() {
      return {
  
        form : {
          id : '',
          uraian : '',
          keterangan : '',
          file : null,
            file_type : '',
             file_old : null,
        },

        file_path: this.$store.state.url.URL_APP + "uploads/",

      
  
        // ====================================== CONTOH AUTOCOMPLETE ====================================
        autocomplete_db : '',
        // ====================================== CONTOH AUTOCOMPLETE ====================================
        
 

       
        list_data : [],
  
        page_first: 1,
        page_last: 0,
        page_limit : 10,
        cari_value: "",
        cek_load_data : true,
  
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_open : false,
        btn_add: false,
  
  
        FETCHING : FETCHING,
        // DATAMASTER : DATAMASTER,
      }
    },
    methods: {
  
  
      getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_SOS + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,
                page_limit : this.page_limit,
                
            })
        })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

  addData: function(){
  
  var formData = new FormData();
  formData.append('pb', JSON.stringify(this.form));
  formData.append('file', this.form.file);
  fetch(this.$store.state.url.URL_SOS + 'addData', {
      method: "POST",
      headers: {
          authorization: "kikensbatara " + localStorage.token
      },
      body: formData
      }).then(res_data => {
        this.getView();
        this.Notify ('Sukses Menambah Data', 'primary', 'check_circle_outline');
  });
  },
  
  
      editData : function(){
        fetch(this.$store.state.url.URL_PRO_KEG + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
        });
      },
  
      removeData : function(E){
        fetch(this.$store.state.url.URL_SOS + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      selectData : function(data){

        console.log(data);
          this.form.id = data.id;
          this.form.uraian = data.uraian;
          this.form.keterangan = data.keterangan;
          this.form.file_old =  data.file
          this.form.file = this.form.file
      },
  
  
      // ====================================== CONTOH eDOC ====================================
   

      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },
          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },

            indexing : function(index){
                var idx = ((this.page_first-1)*this.page_limit)+index
                return idx
            },
  
  
      // ====================================== PAGINATE ====================================
  
  
  
  
  
  
  
    },
  
    mounted () {

      let profilex = JSON.parse(localStorage.profile);
      let profile = profilex.profile;
      // DATAMASTER.getDeskelAsync(this.filterku.des_kel_id);
      // this.form.des_kel_id = profile.des_kel_id;
      // this.filterku.kecamatan_id = profile.kecamatan_id;
      // this.filterku.des_kel_id = profile.des_kel_id;
      this.tipeku = profile.menu_klp;
      // this.form.nama_des_kel = profile.nama_des_kel;

      // console.log("======" + this.filterku.des_kel_id);

      this.getView();



    },
  }
  